import AddIcon from '@mui/icons-material/Add';
import { Paper, Table, TableBody, TableContainer } from '@mui/material';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { useHistory } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { settingsRoutes } from '../../../routes';
import { sortByUsername } from '../../../sic-lib/utils/functionalSort';
import { useAppSelector } from '../../../store/hooks';
import { useUserIsAdmin } from '../../../store/users';
import UsersListItem from './UsersListItem';

export default function UsersList() {
    const { classes } = useStyles();
    const history = useHistory();

    const loggedInUserName = useAppSelector(state => state.user?.userName);
    const isAdmin = useUserIsAdmin();
    const users = useAppSelector(state => state.user?.users || []);

    const usersToShow = React.useMemo(() => {
        if (isAdmin) return [...users].sort(sortByUsername);
        return users.filter(user => user.userName === loggedInUserName).sort(sortByUsername);
    }, [loggedInUserName, isAdmin, users]);

    const handleCreateClick = () => {
        history.push(settingsRoutes.setCreateEditUser());
    };

    return (
        <Grid className={classes.root}>
            {isAdmin && (
                <Grid container justifyContent="flex-end">
                    <Grid item xs="auto" mb={2}>
                        <Button
                            variant="contained"
                            color="primary"
                            startIcon={<AddIcon />}
                            onClick={handleCreateClick}
                        >
                            Create User
                        </Button>
                    </Grid>
                </Grid>
            )}
            <TableContainer component={Paper}>
                <Table>
                    <TableBody>
                        {usersToShow.map(user => (
                            <UsersListItem user={user} key={user.userName} />
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Grid>
    );
}

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        marginBottom: theme.spacing(10),
    },
}));
